import { get, useFormContext } from 'react-hook-form'

export const useFormError = (id: string): string => {
  const {
    formState: { errors },
  } = useFormContext()
  const error = get(errors, id)
  return error?.message
}
